import { useField, useFormikContext } from 'formik';

import { CustomerGroupSelect, type CustomerGroupSelectProps } from '../CustomerGroupSelect/CustomerGroupSelect';

interface FormikCustomerGroupSelectProps extends Omit<CustomerGroupSelectProps, 'onChange' | 'value'> {
    name: string;
    onGroupChange?: (value: string | null) => void;
}

export function FormikCustomerGroupSelect(props: FormikCustomerGroupSelectProps) {
    const [field, meta, helpers] = useField<string | null>(props.name);
    const { validateOnChange } = useFormikContext();

    const onChange = (customerGroupId: string | null) => {
        if (field.value !== customerGroupId) {
            props.onGroupChange?.(customerGroupId);
        }

        helpers.setValue(customerGroupId);
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <CustomerGroupSelect
            {...props}
            onChange={onChange}
            value={field.value}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : props.caption}
            onBlur={() => {
                helpers.setTouched(true);
            }}
        />
    );
}
